import { BookingStatus, Gender, RelocationType } from "@/gql/graphql";

export const bookingMessages = {
  genderLabel: "Gender",
  gender: {
    [Gender.Male]: "Male",
    [Gender.Female]: "Female",
    [Gender.Other]: "Other",
  } satisfies {
    [key in Gender]: string;
  },
  bookings: "Bookings",
  bookingEmpty: {
    title: "No bookings yet",
    subtitle: "Bookings will appear here once customers book your relocations.",
    graphicLabel: "New booking",
  },
  all: "All",
  pending: "Pending",
  confirmed: "Confirmed",
  completed: "Completed",
  cancelled: "Cancelled",
  abandonedCheckout: "Abandoned checkout",
  vip: "VIP",
  booking: "Booking",
  statusLabel: "Status",
  journey: "Journey",
  driver: "Driver",
  deal: "Deal",
  created: "Created",
  statusFilter: "Status",
  supplierFilter: "Supplier",
  departingFrom: "Departing from",
  deliveringTo: "Delivering to",
  vehicle: "Vehicle",
  typeFilter: "Type",
  typeLabels: {
    [RelocationType.Relocation]: "Relocation",
    [RelocationType.GapRental]: "Gap rental",
  },
  hasMatches: "Matches",
  exact: "Exact",
  similar: "Similar",
  broad: "Broad",
  searchPlaceholder: "Search...",

  status: {
    [BookingStatus.AwaitingConfirmation]: "pending",
    [BookingStatus.AwaitingPayment]: "incomplete",
    [BookingStatus.Accepted]: "accepted",
    [BookingStatus.Completed]: "completed",
    [BookingStatus.Confirmed]: "confirmed",
    [BookingStatus.Vip]: "vip",
    [BookingStatus.AdminCancelled]: "admin cancelled",
    [BookingStatus.CustomerCancelled]: "customer cancelled",
    [BookingStatus.CustomerCancelledConfirmationTimeliness]:
      "customer cancelled (timeliness)",
    [BookingStatus.CustomerCancelledNoShow]: "customer cancelled (no show)",
    [BookingStatus.CustomerCancelledRebooked]: "customer cancelled (rebooked)",
    [BookingStatus.SupplierCancelled]: "supplier cancelled",
    [BookingStatus.SupplierCancelledMechanicalFailure]:
      "supplier cancelled (mechanical failure)",
    [BookingStatus.SupplierCancelledNotAvailable]:
      "supplier cancelled (not available)",
    [BookingStatus.SupplierCancelledNoFerry]: "supplier cancelled (no ferry)",
  } satisfies {
    [key in BookingStatus]: string;
  },

  statusShortLabel: {
    [BookingStatus.AwaitingConfirmation]: "pending",
    [BookingStatus.AwaitingPayment]: "incomplete",
    [BookingStatus.Completed]: "completed",
    [BookingStatus.Confirmed]: "confirmed",
    [BookingStatus.Accepted]: "accepted",
    [BookingStatus.Vip]: "vip",
    [BookingStatus.AdminCancelled]: "cancelled (admin)",
    [BookingStatus.CustomerCancelled]: "cancelled (customer)",
    [BookingStatus.CustomerCancelledConfirmationTimeliness]:
      "cancelled (customer)",
    [BookingStatus.CustomerCancelledNoShow]: "cancelled (customer)",
    [BookingStatus.CustomerCancelledRebooked]: "cancelled (customer)",
    [BookingStatus.SupplierCancelled]: "cancelled (supplier)",
    [BookingStatus.SupplierCancelledMechanicalFailure]: "cancelled (supplier)",
    [BookingStatus.SupplierCancelledNotAvailable]: "cancelled (supplier)",
    [BookingStatus.SupplierCancelledNoFerry]: "cancelled (supplier)",
  } satisfies {
    [key in BookingStatus]: string;
  },

  statusInputLabel: {
    [BookingStatus.AwaitingConfirmation]: "pending",
    [BookingStatus.AwaitingPayment]: "incomplete",
    [BookingStatus.Accepted]: "accepted",
    [BookingStatus.Completed]: "completed",
    [BookingStatus.Confirmed]: "confirmed",
    [BookingStatus.Vip]: "vip",
    [BookingStatus.AdminCancelled]: "Other",
    [BookingStatus.CustomerCancelled]: "Other",
    [BookingStatus.CustomerCancelledConfirmationTimeliness]:
      "Confirmation timeliness",
    [BookingStatus.CustomerCancelledNoShow]: "No show",
    [BookingStatus.CustomerCancelledRebooked]: "Rebooked",
    [BookingStatus.SupplierCancelled]: "Other",
    [BookingStatus.SupplierCancelledMechanicalFailure]: "Mechanical failure",
    [BookingStatus.SupplierCancelledNotAvailable]: "Not available",
    [BookingStatus.SupplierCancelledNoFerry]: "No ferry",
  } satisfies {
    [key in BookingStatus]: string;
  },
};
